import { motion } from 'framer-motion'
import { keyProperties } from '../data/mockData'
import { Sparkles } from 'lucide-react'
import PropertyCard from '../compenents/PropertyCard'

const Properties = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <Sparkles className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gradient mb-6">Propriétés Écologiques</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez les propriétés exceptionnelles de nos produits ECOTHERM qui révolutionnent l'industrie de l'isolation. Des matériaux naturels aux performances inégalées.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {keyProperties.map((property, index) => (
            <motion.div
              key={property.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <PropertyCard property={property} />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8 }}
          className="mt-20 bg-gradient-to-br from-green-600 to-green-700 rounded-3xl p-12 text-white"
        >
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center">Avantages Environnementaux</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">🌱</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Zéro Émission de CO2</h3>
                  <p className="opacity-90">Nos produits ne dégagent aucun gaz à effet de serre lors de leur production et application.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">💧</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Économie d'Eau</h3>
                  <p className="opacity-90">Aucun besoin d'eau pour le mélange, préservant cette ressource vitale.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">♻️</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">100% Recyclable</h3>
                  <p className="opacity-90">Tous nos matériaux sont recyclables et biodégradables.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">🏡</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Santé Intérieure</h3>
                  <p className="opacity-90">Améliore la qualité de l'air intérieur en capturant les polluants.</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Properties